module.exports = __webpack_public_path__ + "static/slide4-7188e0900f7215db9bac146fb56d2e3b.jpg";